import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

interface InfoBoxProps {
  isErrorInfo?: boolean;
  title: string | JSX.Element;
  body: string | JSX.Element | null;
  footer?: string | JSX.Element | null;
}

const Box = styled.div<{ isErrorInfo: boolean }>`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
  flex: 1;
  background: ${(props) =>
    props.isErrorInfo ? tokens.color.bg_danger : tokens.color.ui_background};
  border: 1px solid ${tokens.color.ui_border_light};
  box-sizing: border-box;
  ${tokens.elevation(1)};
  border-radius: 4px;
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  padding: 0px 0px ${tokens.spacer.x1} 0px;
`;

const FooterSection = styled.div`
  margin-top: auto;
`;

export const InfoBox = ({
  title,
  body,
  footer,
  isErrorInfo = false,
}: InfoBoxProps): JSX.Element => {
  return (
    <Box isErrorInfo={isErrorInfo}>
      {title && <Section>{title}</Section>}
      {body && <Section>{body}</Section>}
      {footer && <FooterSection>{footer}</FooterSection>}
    </Box>
  );
};
